/**
 * Pure signup onboarding-intent body builder (no DOM).
 */

import { buildSignupTaxPayload } from "./signup-tax.js";
import { normalizePhone, stripPhoneDigits } from "../utils/phone.js";
import {
  countryDisplayLabel,
  isSelfServeCountryEnabled,
  signupChromeForCountry,
  signupLocaleForCountry,
} from "./self-serve-countries.js";

/**
 * Build intent body from form fields (testable).
 * @param {{ country: string, taxId: string, responsibleName: string, contactEmail: string, contactPhone: string, acquisition?: Record<string, string> }} input
 * @returns {Record<string, unknown>}
 */
export function buildSignupIntentBody(input) {
  const country = String(input.country || "BR").trim().toUpperCase() || "BR";
  if (!isSelfServeCountryEnabled(country)) {
    throw new Error(
      `Signup self-serve para ${countryDisplayLabel(country)} ainda não está disponível.`
    );
  }

  const taxPayload = buildSignupTaxPayload({
    country,
    taxId: input.taxId,
  });
  const chrome = signupChromeForCountry(country);
  const phoneDigits = stripPhoneDigits(input.contactPhone);
  const phoneNormalized = phoneDigits
    ? normalizePhone(input.contactPhone, chrome.phoneRegion)
    : "";

  /** @type {Record<string, unknown>} */
  const body = {
    responsible_name: String(input.responsibleName || "").trim(),
    contact_email: String(input.contactEmail || "").trim(),
    contact_phone: phoneNormalized || phoneDigits || null,
    country: taxPayload.country,
    tax_id: taxPayload.tax_id,
    tax_id_type: taxPayload.tax_id_type,
    locale: signupLocaleForCountry(country),
  };
  if (taxPayload.company_cnpj) {
    body.company_cnpj = taxPayload.company_cnpj;
  }
  if (input.acquisition && Object.keys(input.acquisition).length) {
    body.acquisition = { ...input.acquisition };
  }

  if (!body.responsible_name || !body.contact_email || !body.tax_id) {
    throw new Error("Preencha documento fiscal, nome do responsável e email para continuar.");
  }
  return body;
}
